import './PolicyStyles.css';
import { exportToWord } from '../utils/exportToWord';

const SubcontractorManagementPolicy = ({
  clientName,
  companyNumber,
  clientAddress,
  effectiveDate,
  procurementContact,
  complianceOfficerContact,
}) => {
  const handleExportToWord = () => {
    const policyContent = document.getElementById('policy-content');
    exportToWord(policyContent.innerHTML, "Subcontractor_Management_Policy.docx");
  };

  return (
    <div className="policy-container" id="policy-content">
      <h3 className="policy-title">Subcontractor Management Policy</h3>

      <p className="policy-details"><strong>Company Name:</strong> {clientName || "[Insert Company Name]"}</p>
      <p className="policy-details"><strong>Company Number:</strong> {companyNumber || "[Insert Company Number]"}</p>
      <p className="policy-details"><strong>Company Address:</strong> {clientAddress || "[Insert Company Address]"}</p>
      <p className="policy-details"><strong>Policy Effective Date:</strong> {effectiveDate || "[Insert Effective Date]"}</p>

      <h4 className="section-title">1. Purpose</h4>
      <p className="section-content">
        This policy defines the standards and procedures for selecting, engaging, and managing subcontractors who provide services to {clientName || "the Company"}, excluding temporary or agency drivers.
      </p>

      <h4 className="section-title">2. Scope</h4>
      <p className="section-content">
        Applies to all subcontractors contracted for services including maintenance, logistics support, administration, and other non-driver roles.
      </p>

      <h4 className="section-title">3. Subcontractor Selection and Vetting</h4>
      <ul>
        <li>All subcontractors must undergo a thorough vetting process including verification of qualifications, insurance, licenses, and compliance with legal and company standards.</li>
        <li>References and past performance will be evaluated prior to engagement.</li>
        <li>Contracts must clearly define the scope, deliverables, liabilities, and compliance requirements.</li>
      </ul>

      <h4 className="section-title">4. Contract Management</h4>
      <ul>
        <li>Subcontract agreements shall include clauses on confidentiality, data protection, health and safety, and anti-bribery compliance.</li>
        <li>Performance will be regularly reviewed against contract terms.</li>
        <li>Non-compliance may result in termination of contract.</li>
      </ul>

      <h4 className="section-title">5. Health, Safety and Compliance</h4>
      <ul>
        <li>Subcontractors must comply with all relevant health and safety regulations and company policies.</li>
        <li>Evidence of compliance and insurance must be maintained and available for audit.</li>
        <li>Subcontractors shall report any incidents or hazards to the company promptly.</li>
      </ul>

      <h4 className="section-title">6. Communication and Coordination</h4>
      <p className="section-content">
        Clear communication channels will be established to ensure effective coordination and timely issue resolution.
      </p>

      <h4 className="section-title">7. Roles and Responsibilities</h4>
      <p className="section-content"><strong>Procurement Team:</strong> Responsible for subcontractor selection and contract administration. Contact: {procurementContact || "[Insert Contact]"}</p>
      <p className="section-content"><strong>Compliance Officer:</strong> Monitors subcontractor compliance with policies and regulations. Contact: {complianceOfficerContact || "[Insert Contact]"}</p>
      <p className="section-content"><strong>Subcontractors:</strong> Must adhere to contract terms, company policies, and legal requirements.</p>

      <h4 className="section-title">8. Review and Continuous Improvement</h4>
      <p className="section-content">
        This policy and subcontractor management practices will be reviewed periodically to improve effectiveness and address changing business needs.
      </p>

      <h4 className="section-title">Employee Acknowledgment and Signature</h4>
      <p>I confirm that I have read, understood, and will comply with the Subcontractor Management Policy.</p>
      <p>Employee Name: _________________________</p>
      <p>Employee Signature: _________________________</p>
      <p>Date: _________________________</p>

      <h4 className="section-title">Management Approval and Signature</h4>
      <p>This policy has been approved by senior management and is now in effect.</p>
      <p>Manager/Officer Name: _________________________</p>
      <p>Title: _________________________</p>
      <p>Signature: _________________________</p>
      <p>Date: _________________________</p>

      <div className="mt-4 text-center">
        <button
          onClick={handleExportToWord}
          className="bg-green-600 text-white px-6 py-2 rounded hover:bg-green-700 transition"
        >
          Export to Word
        </button>
      </div>
    </div>
  );
};

export default SubcontractorManagementPolicy;
